import {
  FDContentContainer,
  FDIcon,
  FDStack, FDTitleText, FDTooltip,
} from '@facet-wealth/design';
import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import TaxStrategyMetaOverride
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyMetaOverrideSet';
import TaxStrategySettingLayout
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategySettingLayout';
import MetaControl from 'Components/UI/Meta/MetaControl';
import TaxStrategySettingsTabColumnLabels
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyTabs/TaxStrategySettingsTabColumnLabels';
import {
  useTabContentContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Context';
import PropTypes from 'prop-types';
import {
  TaxStrategyGainsBudgetCalculatorView,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyGainsCalculatorView';
import fr from 'facet-rest';
import TaxStrategyInternalNotes
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyInternalNotes';

const TaxStrategySettingsTabLayout = ({ onSubmit }) => {
  const { activeTabResource } = useTabContentContext();
  const resource = activeTabResource.attr('settingsTab').resources().head();
  const [capitalGainsCalculatorOpenForResource, setCapitalGainsCalculatorOpenForResource] = React.useState(null);

  if (capitalGainsCalculatorOpenForResource) {
    return (
      <TaxStrategyGainsBudgetCalculatorView
        open={!!capitalGainsCalculatorOpenForResource}
        taxStrategyGainsBudgetCalculatorRelationship={capitalGainsCalculatorOpenForResource.relationship(fr.relationships.gainsBudgetCalculator.name)}
        onClose={() => {
          setCapitalGainsCalculatorOpenForResource(null);
          onSubmit();
        }}
        taxSettingsResource={capitalGainsCalculatorOpenForResource}
      />
    );
  }

  return (
    <FDStack direction={'row'} spacing={3} flexGrow={1}>
      <FDContentContainer maxWidth={'lg'} flexGrow={1}>
        <FDStack direction={'column'} justifyContent="center" spacing={3}>
          {resource.attr('defaultSettings').resources().length() > 0 && (
            <>
              <MetaControl attrName={'title'} resource={resource} metaOverrideSet={TaxStrategyMetaOverride} />
              <MetaControl attrName={'subtitle'} resource={resource} metaOverrideSet={TaxStrategyMetaOverride} />
              {resource.isTruthy('showTaxesPaidHeader') && (
                <FDStack direction={'row'} spacing={4}>
                  <FDStack direction={'row'} spacing={1}>
                    <FDTitleText value={'Taxes Paid Before'} />
                    <FDTitleText color={'textSecondary'} value={`${resource.attr('totalTaxPaidNoSettings') || '-'}`} />
                  </FDStack>
                  <FDStack direction={'row'} spacing={1}>
                    <FDTitleText value={'Taxes Paid After'} />
                    <FDTitleText color={'textSecondary'} value={`${resource.attr('totalTaxPaidWithSettings') || '-'}`} />
                  </FDStack>
                  <FDStack direction={'row'} spacing={1}>
                    <FDStack direction={'row'} spacing={1} alignItems={'center'}>
                      <FDTitleText value={'Total Lifetime Value'} />
                      {resource.metaField('totalLifetimeValue').attr('description') && (
                      <FDTooltip
                        title={resource.metaField('totalLifetimeValue').attr('description')}
                        placement="top"
                      >
                        <FDIcon icon={'info'} color={'primary'} size={'sm'} />
                      </FDTooltip>
                      )}
                    </FDStack>
                    <FDTitleText color={'textSecondary'} value={`${resource.attr('totalLifetimeValue') || '-'}`} />
                  </FDStack>
                </FDStack>
              )}
              <TaxStrategySettingsTabColumnLabels resource={resource} />
              <FDStack direction={'column'} spacing={3} justifyContent={'space-between'}>
                {resource.attr('defaultSettings').resources().list().map((settingsResource) => (
                  <MetaResourceRenderer
                    key={settingsResource.id()}
                    resource={settingsResource}
                    metaOverrideSet={TaxStrategyMetaOverride}
                    layout={TaxStrategySettingLayout}
                    LayoutProps={{
                      setCapitalGainsCalculatorOpenForResource,
                    }}
                  />
                ))}
              </FDStack>
            </>
          )}
          <MetaControl attrName={'additionalSettingsTitle'} resource={resource} metaOverrideSet={TaxStrategyMetaOverride} />
          <TaxStrategySettingsTabColumnLabels resource={resource} />
          <FDStack direction={'column'} spacing={3}>
            { resource.attr('additionalSettings').resources().list().map((settingsResource) => (
              <MetaResourceRenderer
                key={settingsResource.id()}
                resource={settingsResource}
                metaOverrideSet={TaxStrategyMetaOverride}
                layout={TaxStrategySettingLayout}
                LayoutProps={{
                  setCapitalGainsCalculatorOpenForResource,
                }}
              />
            ))}
          </FDStack>
        </FDStack>
      </FDContentContainer>
      <TaxStrategyInternalNotes onSubmit={onSubmit} />
    </FDStack>
  );
};

TaxStrategySettingsTabLayout.defaultProps = {
  onSubmit: () => {},
};

TaxStrategySettingsTabLayout.propTypes = {
  onSubmit: PropTypes.func,
};

export default TaxStrategySettingsTabLayout;
